import { createGlobalState } from "@vueuse/core";
import type { UserDetail } from "@/constants/interfaces";
import { reactive, ref, shallowRef } from "vue";
import ChatWootClientApiServices from "@/assets/services/chatwoot/clientApiServices";
import axios from "axios";
import { useChatMessageInfo } from "./chatInfo.store";
import { PartnerName } from "@/constants/common-constants";
import { storeToRefs } from "pinia";
import { useEnvConfigStore } from "./env.store";
import { getLabelName, IsNullorWhiteSpace } from "@/utilities/utilities";
import { AddLabels, CreateContact, CreateConversation, GetAnswerByArtCatId, GetFaqs } from "@/constants/url-constants";
import { SpanSupportApiServices } from "@/assets/services/spanSupport/apiServices";

export const useGlobalStore = createGlobalState(() => {
  const chatWootClientApiServices = reactive(new ChatWootClientApiServices());
   const spanSupportApiServices = reactive(new SpanSupportApiServices());
  const {ContactDetails,ConversationDetails,LiveAgentChatMessageDetails} = storeToRefs(useChatMessageInfo())
  const {aiChatBotKeys } = storeToRefs(useEnvConfigStore())
  const AuthenticationDetails = reactive({
    IsAuthenticateUser: false as Boolean,
    IsUserAutenticated: false as Boolean,
  });
  const UserDetails = ref<UserDetail>();

  const IsHideHeadSection = ref<boolean>(false);

  let CustomMessage = ref<Record<string, string>>({});

  const UserMetaDataDetails = ref<Record<string, string>>({});
  const IsLiveChatConversationCreated = ref<boolean>(false);
  const IsCustomMessageAnswerReceived = ref<boolean>(true);
  const HelpArticleId = ref<string>("")
  const ActiveComponent = shallowRef<string>("UserLogin")
  const IsFocusSearch = ref<boolean>(false)
  const NotificationCount  = ref<number>(0)
  const isGetLatestLiveChat = ref<boolean>(false)
  const BotIconPath = ref<string>("")
  const IsStartNewChat = ref<boolean>(false)
  const IsLiveChatContactCreated = ref<boolean>(false);
  const UserBrowserDetails = ref<Record<string, string>>({});
  const TotalNotificationCount = ref<number>(0)
  const CurrentSpanBotAccessKey = ref<string>("")
  const CurrentSpanBotUSPSAccessKey = ref<string>("")
  const CurrentSpanBotReturnStatusAccessKey = ref<string>("")
  const CurrentSpanBotYoutubeAccessKey = ref<string>("")
  const CurrentSpanBotUrl = ref<string>("")
  const CacheHelpArticleAnswers = ref({})
  const CacheChatConversationHistory = ref([])


  function ChatCommandCommunication(command: Object) {
    window.parent.postMessage(JSON.stringify(command), "*");
  }

  // Create new contact based on the Email Address
  async function createContact() {
    const contactName = UserDetails.value?.ContactName || UserDetails.value?.EmailAddress?.split('@')[0]
    const createContactRequest = {
      email: UserDetails.value?.EmailAddress,
      name: contactName,
      custom_attributes:{
      city: UserMetaDataDetails.value.City,
      country:UserMetaDataDetails.value.Country,
      platform:UserBrowserDetails.value.platform,
      browsername:UserBrowserDetails.value.BrowserName,
      browserversion:UserBrowserDetails.value.BrowserVersion,
      os:UserBrowserDetails.value.OSName,
      osversion:UserBrowserDetails.value.OSVersion,
      ipaddress:UserMetaDataDetails.value.IpAddress
      }
    };
    spanSupportApiServices
      .postMethod(CreateContact, createContactRequest)
      .then((res) => {
         ContactDetails.value = res;
         IsLiveChatContactCreated.value = true
        //  createConversation()
      })
      .catch((err) => {
        // console.log(err);
      });
  }

  //Create new conversation
  async function createConversation() {
    // const isSageUser = UserDetails.value?.PartnerName?.toLowerCase()?.includes(PartnerName.Sage.toLowerCase())
    const createConversationRequest = {
      ContactId:ContactDetails.value.source_id,
      custom_attributes:{
        team_id:aiChatBotKeys.value?.LiveChatTeamID,
          city: UserMetaDataDetails.value.City,
          country:UserMetaDataDetails.value.Country,
          platform:UserBrowserDetails.value.platform,
          browsername:UserBrowserDetails.value.BrowserName,
          browserversion:UserBrowserDetails.value.BrowserVersion,
          os:UserBrowserDetails.value.OSName,
          osversion:UserBrowserDetails.value.OSVersion,
          ipaddress:UserMetaDataDetails.value.IpAddress
      }
    }

    spanSupportApiServices
      .postMethod(CreateConversation,createConversationRequest)
      .then((res) => {
        ConversationDetails.value = res;
        AddLabelsToConversation()
        IsLiveChatConversationCreated.value = true
      })
      .catch((err) => {
        // console.log(err);
      });
  }

    //Get User Meta Data Details
    const getUserMetaData = async () => {
      try{
        const url = "https://ipinfo.io/json";
        const response = await axios.get(url)
        const clientMetaDetails = response.data
        if(!IsNullorWhiteSpace(clientMetaDetails)){
        UserMetaDataDetails.value = {
          IpAddress: clientMetaDetails?.ip,
          Country: clientMetaDetails?.country,
          ZIP: clientMetaDetails?.postal,
          Region: clientMetaDetails?.region,
          City: clientMetaDetails?.city
        };
        }
      }
      catch(error)
      {
        //console.log(error)
      }
      
      if(IsNullorWhiteSpace(UserMetaDataDetails.value) ||Object.keys(UserMetaDataDetails.value).length == 0)
      {
        await axios.get('https://get.geojs.io/v1/ip/geo.json')
        .then(res=>res.data)
        .then((data)=>{
          UserMetaDataDetails.value = {
          IpAddress:data?.ip,
          Country: data?.country,
          ZIP: data?.postal,
          Region: data?.region,
          City: data?.city
          };
        })
        .catch((error)=>{
          //console.log(error)
        })
      }
    };

    async function GetHelpQuestionAnswers(request:Record<string,string>) {
      const response = await spanSupportApiServices.getMethod(GetFaqs,request)
       .then((res)=>res)
       .catch((err)=>{
        throw new Error(err);
       })

       return response
    }

    async function GetAnswerBasedOnQuestions(request:Record<string,string>) {
      const response =   await spanSupportApiServices.getMethod(GetAnswerByArtCatId,request)
       .then((res)=>res)
       .catch((err)=> {
         throw new Error(err);
       })
       return response
    }


   async function AddLabelsToConversation()
    {
      const addLabelsRequest = {
        ConversationId:ConversationDetails.value.id,
        LabelName: getLabelName()
      }
      try{
      const response  = await spanSupportApiServices.postMethod(AddLabels,addLabelsRequest).then((res)=>res).catch((e)=>e)
      // console.log(response)
      }
      catch(e)
      {
        console.log(e)
      }
    }
  return {
    AuthenticationDetails,
    UserDetails,
    ChatCommandCommunication,
    IsHideHeadSection,
    CustomMessage,
    IsLiveChatConversationCreated,
    createContact,
    createConversation,
    UserMetaDataDetails,
    getUserMetaData,
    IsCustomMessageAnswerReceived,
    HelpArticleId,
    ActiveComponent,
    IsFocusSearch,
    NotificationCount,
    BotIconPath,
    isGetLatestLiveChat,
    IsStartNewChat,
    IsLiveChatContactCreated,
    UserBrowserDetails,
    TotalNotificationCount,
    CurrentSpanBotAccessKey,
    CurrentSpanBotUSPSAccessKey,
    CurrentSpanBotReturnStatusAccessKey,
    CurrentSpanBotYoutubeAccessKey,
    CurrentSpanBotUrl,
    GetHelpQuestionAnswers,
    GetAnswerBasedOnQuestions,
    CacheHelpArticleAnswers,
    CacheChatConversationHistory
  };
});
